import {AxiosError} from 'axios';
import {PUT_CREATE_SPECIAL_CONSIDERATION_AMENDMENT_DRAFT_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutSpecialConsiderationAmendmentDraft = ({uuid, onSuccess, onError}: Input) => {
  const putSpecialConsiderationAmendmentDraft = async () => {
    await axiosClient.put(PUT_CREATE_SPECIAL_CONSIDERATION_AMENDMENT_DRAFT_URL(uuid));
  };

  return useCustomMutation(putSpecialConsiderationAmendmentDraft, {
    onSuccess,
    onError,
  });
};
